import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { CustomExcelMapperRoutingModule } from './custom-excel-mapper-routing.module';
import { CustomExcelMapperComponent } from './custom-excel-mapper.component';
import { MatIconModule } from '@angular/material/icon';
import { MatStepperModule } from '@angular/material/stepper';
import { FileUploadModule } from 'ng2-file-upload';
import { NgxMatSelectSearchModule } from 'ngx-mat-select-search';
import { DirectiveModule } from '../directive/directive.module';
import { SharedModule } from '../shared.module';


@NgModule({
  declarations: [
    CustomExcelMapperComponent
  ],
  imports: [
    CommonModule,
    CustomExcelMapperRoutingModule,
    SharedModule,
    MatIconModule,
    DirectiveModule,
    NgxMatSelectSearchModule,
    FileUploadModule,
    MatStepperModule,
  ],exports:[
    CustomExcelMapperComponent
  ]
})
export class CustomExcelMapperModule { }
